import { EMessengerLaunchContext } from '@xometry/ui';
import { useStore } from 'stores/RootStore';
import { ESideOverlayType } from 'stores/SideOverlay/SideOverlayStore';

export const useEmbedded = () => {
  const { sideOverlayStore } = useStore();

  const launchContext =
    sideOverlayStore.context.type === ESideOverlayType.Messenger
      ? (sideOverlayStore.context.launchContext as EMessengerLaunchContext)
      : null;

  const isSfEmbedded = launchContext === EMessengerLaunchContext.EMBEDDED_SF;
  const isGshEmbedded = launchContext === EMessengerLaunchContext.EMBEDDED_GSH;

  return {
    isEmbedded: isSfEmbedded || isGshEmbedded,
    isSfEmbedded,
    isGshEmbedded,
  };
};
